import { Space } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { DynamicObjectType } from 'types/commons';
import ProductsOrder from './ProductOrder';
import PaymentInformation from './PaymentInformation';
import OrderHistories from './OrderHistories';
import ExchangeInformation from './ExchangeInformation';

const OrderLeftContentStyle = styled.div`
  .order-items {
    padding: 0px;
    .ant-card-body {
      padding: 0px;
    }
    .ant-table-cell {
      background-color: transparent;
    }
  }
`;

const LeftContent = ({ data }: DynamicObjectType) => {
  return (
    <OrderLeftContentStyle>
      <Space className="w-full" size={20} direction="vertical">
        <ProductsOrder
          data={data?.orderReturn}
          items={data?.orderReturn?.items}
          title="Return Items"
          order={data}
        />
        <ProductsOrder
          data={data?.newOrder}
          items={data?.newOrder?.items}
          title="Exchange Items"
          isExchange
          order={data}
        />
        <PaymentInformation data={data} />
        <ExchangeInformation data={data} />
        <OrderHistories data={data} />
      </Space>
    </OrderLeftContentStyle>
  );
};

export default LeftContent;
